import React from "react"
import { useTranslation } from "react-i18next"
import YMaps from "components/YMaps"
import { Line } from "./style"
import { FiArrowLeft } from "react-icons/fi"
import { useNavigate } from "react-router-dom"

export default () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  // const { categories, regions, groups, users } = useSelector(
  //   (state) => state.appReducer
  // )
  // const [cardData, setCardData] = useState([])
  // const [pageNum, setPageNum] = useState(0)
  // const [total, setTotal] = useState(0)
  // const [loading, setLoading] = useState(false)
  // const [pageType, setPageType] = useState(0)
  // const { constructorMethod } = workConstructor()

  // useEffect(() => {
  //   if (pageType) {
  //     const common = { categories, regions, groups, users }
  //     setLoading(true)
  //     const reqBody = {
  //       page: pageNum + 1,
  //       limit: 2,
  //     }
  //     works
  //       .getAll(reqBody)
  //       .then(({ docs, totalDocs }) => {
  //         const filledWorks = constructorMethod(docs, common)
  //         setCardData(() => [...filledWorks])
  //         setTotal(() => totalDocs)
  //       })
  //       .catch((err) => console.error(err))
  //       .finally(() => setLoading(false))
  //   }
  // }, [pageType])

  // if (loading) {
  //   return <Spinner />
  // }
  return (
    <div className=" py-9 px-4 text-white">
      <button
        onClick={() => navigate(-1)}
        className="flex items-center justify-start text-base gap-2 cursor-pointer mb-8"
      >
        <FiArrowLeft size={25} />
        <span className="text-xl font-medium">{t("back")}</span>
      </button>
      <div className="flex flex-col  justify-between gap-8">
        <div className="w-full flex flex-col justify-center">
          <h1 className="text-3xl font-bold leading-9 pb-4">
            {t("about-site")}
          </h1>
          <p className="font-normal text-base leading-6 ">
            {t("about_project")}
          </p>
        </div>
        <div className="w-full">
          <div>
            <p className="font-semibold text-white text-[32px]">
              {t("finding-in-map")}
            </p>
            <Line />
          </div>
          <div className="w-full h-[500px]">
            <YMaps />
          </div>
        </div>
      </div>
    </div>
  )
}
